import _ from 'lodash'
import { MutationTree } from 'vuex';
import { Application, ApplicationsState } from '@/store/applications/types';
import { Pager } from '@/store/pager.types';

const mutations: MutationTree<ApplicationsState> = {
  fetchedApplications: (
    state,
    {
      applications,
      pager,
    }: {
      applications: Application[],
      pager: Pager,
    },
  ) => {
    state.applications = applications
    state.pager = pager
  },
  gotApplication: (state, application: Application) => {
    state.applications = _.uniqBy([
      application,
      ...state.applications,
    ], 'id')
  },
};

export default mutations;
